import { render, staticRenderFns } from "./TzDetail.vue?vue&type=template&id=b305ecaa"
import script from "./TzDetail.vue?vue&type=script&lang=js"
export * from "./TzDetail.vue?vue&type=script&lang=js"
import style0 from "./TzDetail.vue?vue&type=style&index=0&id=b305ecaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports